__webpack_require__.p = "/hero-academy/";